export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    close: '閉じる',
    gender: {
      male: '男/M',
      female: '女/F'
    },
    money: '<currency>JPY</currency> <amount>{{amount}}</amount>',
    moneyText: 'JPY {{amount}}',
    refundMethod: {
      credit: 'クレジットカード',
      union: '銀聯カード',
      alipay: 'Alipay',
      wechatpay: 'WeChat Pay',
      cash: '現金'
    }
  },
  components: {
    passportCamera: {
      hint: 'パスポートの顔写真ページを枠に合わせてください',
      unavailable:
        'カメラを起動できません。標準カメラで撮影するか、写真を選択してください。',
      systemCamera: '標準カメラで撮影',
      album: 'アルバム',
      shoot: '撮影'
    }
  },
  views: {
    home: {
      title: 'ホーム',
      notice: '返還待ちの消費税があります',
      apply: '免税申請',
      historyTitle: '申請履歴',
      total: '総額',
      refundAmount: '返金予定',
      empty: '申請履歴はありません',
      loadError: '読み込みに失敗しました。しばらくしてから再度お試しください。',
      applyError:
        '申請の送信に失敗しました。しばらくしてから再度お試しください。',
      status: {
        awaitingCustoms: '税関確認待ち',
        notEligible: '免税条件を満たしません',
        refunding: '返金処理中',
        refunded: '返金完了',
        refundFailed: '返金失敗'
      }
    },
    landing: {
      title: '日本免税還付サービス',
      description: '出国確認後、URL から\n本サービスにアクセスいただきました',
      next: '次へ進む'
    },
    login: {
      title: '日本免税還付サービス',
      google: 'Googleでログイン',
      email: 'メールアドレスでログイン',
      emailLabel: 'メールアドレス',
      sendLink: 'ログインリンクを送信',
      resendLink: 'ログインリンクを再送信',
      linkSent:
        '{{email}} にログインリンクを送信しました。\nメールをご確認ください。',
      confirmEmail:
        'ログインを完了するため、メールアドレスを再入力してください。',
      submit: 'ログイン',
      loginError:
        'ログインに失敗しました。しばらくしてから再度お試しください。',
      sendError: '送信に失敗しました。しばらくしてから再度お試しください。'
    },
    passportInfo: {
      title: 'パスポート情報',
      nationality: '国籍',
      passportNumber: 'パスポート番号',
      lastName: '姓',
      firstName: '名',
      gender: '性別',
      dateOfBirth: '生年月日',
      dateOfExpiry: '有効期限',
      confirm: '確認',
      rescan: '認識エラー・再撮影',
      scanError: 'パスポートを読み取れませんでした。もう一度撮影してください。',
      bindError: '登録に失敗しました。しばらくしてから再度お試しください。'
    },
    passports: {
      title: 'パスポート一覧',
      add: 'パスポートを追加',
      delete: '削除',
      deleteConfirm: 'パスポート {{number}} を削除しますか？',
      loadError: '読み込みに失敗しました。しばらくしてから再度お試しください。',
      deleteError: '削除に失敗しました。しばらくしてから再度お試しください。',
      selectError:
        'パスポートの切り替えに失敗しました。しばらくしてから再度お試しください。',
      logout: 'ログアウト'
    },
    taxInfo: {
      title: '退税書類情報の入力',
      passportLabel: 'パスポート番号',
      passportPlaceholder: '入力してください',
      lastNameLabel: '姓',
      lastNamePlaceholder: '入力してください',
      firstNameLabel: '名',
      firstNamePlaceholder: 'ミドルネームと名',
      expiryLabel: 'パスポート有効期限',
      verifyError:
        'パスポート情報の照合に失敗しました。入力内容をご確認ください。',
      submit: '照合して次へ進む'
    },
    residenceCert: {
      title: '在留資格証明書',
      notice:
        '2年以上海外に居住していることを確認するため、以下のいずれかの証明書をご提出ください。',
      documentLabel: '海外居住証明（いずれか1点）',
      types: {
        permitDocumentTypeKosekiFukuhyo: '戸籍附票',
        permitDocumentTypeResidenceCertificate: '海外在留証明',
        permitDocumentTypeMynumberCard: 'マイナンバーカード'
      },
      residenceStatusLabel: '在留資格',
      residenceStatusPlaceholder: '選択してください',
      permitTypes: {
        shipTourism: '船舶観光上陸許可',
        crew: '乗員上陸許可',
        emergency: '緊急上陸許可',
        distress: '遭難による上陸許可',
        sofa: '米軍構成員',
        portCall: '寄港地上陸許可',
        transit: '通過上陸許可'
      },
      entryDateLabel: '入国日',
      settledDateLabel: '海外定住日',
      datePlaceholder: 'yyyy-mm-dd',
      addressLabel: '海外居住地',
      countryPlaceholder: '選択してください',
      uploadLabel: '画像をアップロード',
      capture: '撮影する',
      removeImage: '画像を削除',
      submit: 'アップロード',
      verifyError:
        'リンクが無効または期限切れです。もう一度QRコードを読み取ってください。'
    },
    uploadResult: {
      title: 'アップロード結果',
      done: 'アップロード完了',
      desc: 'Kioskに戻り、操作を続けてください',
      failed: 'アップロードに失敗しました',
      failedDesc: '再度操作を行ってください'
    },
    statusDetail: {
      title: '申請ステータス詳細',
      orderNo: '注文番号 {{id}}',
      appliedAt: '申請日 {{date}}',
      appliedAt_method: '申請日 {{date}}｜{{method}}',
      total: '総額',
      taxAmount: '税額',
      refundFee: '手数料',
      refundAmount: '返金予定',
      customsNotice:
        '出国時に税関で購入商品の確認をお受けください。確認完了後、返金処理が開始されます。',
      steps: {
        received: '申請受付完了',
        customsPending: '税関出境確認中',
        customs: '税関出境確認完了',
        customsFailed: '税関審査未通過',
        refunding: '返金処理中',
        refunded: '返金完了',
        refundFailed: '返金失敗'
      },
      remitNote: '通常3〜5営業日',
      retry: '再申請する',
      retryError: '再申請に失敗しました。しばらくしてから再度お試しください。',
      loading: '読み込み中...',
      loadError: '読み込みに失敗しました。しばらくしてから再度お試しください。'
    },
    notFound: {
      title: 'ページが見つかりません',
      description: 'お探しのページは存在しないか、移動された可能性があります。',
      backHome: 'ホームに戻る'
    }
  }
};
